import {
  Box,
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalTitle,
  Typography,
} from '@cambridgeassessment/cambridge-ui';
import React from 'react';

interface ConfirmationModalProps {
  open: boolean;
  action: 'approve' | 'reject';
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  open,
  action,
  onConfirm,
  onCancel,
}) => {
  const isApprove = action === 'approve';
  const title = isApprove ? 'Confirm Approval' : 'Confirm Rejection';
  const body = isApprove
    ? 'Are you sure you want to approve this registration?'
    : 'Are you sure you want to reject this registration?';

  return (
    <Modal
      open={open}
      size="small"
      onClose={onCancel}
      data-testid="bookings-confirmation-modal"
    >
      <Box>
        <ModalTitle
          onClose={onCancel}
          data-testid="bookings-confirmation-title"
        >
          {title}
        </ModalTitle>
      </Box>
      <ModalContent>
        <Typography variant="body1" data-testid="bookings-confirmation-body">
          {body}
        </Typography>
      </ModalContent>
      <ModalActions>
        <Button
          onClick={onCancel}
          color="primary"
          variant="text"
          data-testid="bookings-confirmation-cancel"
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          data-testid="bookings-confirmation-confirm"
        >
          Confirm
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default React.memo(ConfirmationModal);
